
import "./filesize.coffee"
